import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { BrandLogo } from '../site-header/brand-logo';
import '../../../hs-theme.css';
import './footer.css';

const COLUMNS = [
    {
        title: 'footer_search',
        links: [
            { title: 'buy', path: '/prodaja' },
            { title: 'rent', path: '/izdavanje' },
            { title: 'daily', path: '/stan-na-dan' },
        ]
    },
    {
        title: 'info',
        links: [
            { title: 'sellers', path: '/uputstvo-prodavci' },
            { title: 'tenants', path: '/uputstvo-zakupci' },
            { title: 'advertisement', path: '/upustvo-oglasavanje' },
            { title: 'tax_refund', path: '/vodic/povracaj-poreza' },
        ]
    },
    {
        title: 'footer_account',
        links: [
            { title: 'login', path: '/login' },
            { title: 'create_listing', path: '/postavi-oglas' },
            { title: 'my_panel', path: '/korisnik/podaci' },
        ]
    },
];

export const Footer = () => {
    const { t } = useTranslation(["navigation"]);
    const clearPage = () => sessionStorage.removeItem('currentPage');

    return (
        <footer className='hs hs-footer'>
            <div className='hs-footer-main'>
                <div className='hs-footer-brand'>
                    <BrandLogo />
                    <div className='hs-footer-address'>
                        <p className='hs-footer-company'>Halo Stan Nekretnine Beograd</p>
                        <p>Jurija Gagarina 22, Novi Beograd 11070</p>
                        <p>{t('footer_phone')}: <a href="tel:062048423">062 048 423</a></p>
                    </div>
                </div>
                {COLUMNS.map(column => (
                    <div className='hs-footer-column' key={column.title}>
                        <p className='hs-footer-column-title'>{t(column.title)}</p>
                        {column.links.map(link => (
                            <Link key={link.path} to={link.path} onClick={clearPage}>{t(link.title)}</Link>
                        ))}
                    </div>
                ))}
            </div>
            <div className='hs-footer-bottom'>
                <span>© {new Date().getFullYear()} HaloStan Nekretnine. {t('footer_rights')}</span>
                <span className='hs-footer-legal'>
                    <Link to='/terms'>{t('footer_terms')}</Link>
                    <Link to='/privacy'>{t('footer_privacy')}</Link>
                </span>
            </div>
        </footer>
    );
}
